import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

import { LicenseCashReportsComponent } from './licenseCashReports/licenseCashReports.component';
import { ReportsRoutingModule } from './reports-routing.module';
import { MailingLabelsComponent } from './mailingLabels/mailingLabels.component';
import { DemographicsReportComponent } from './demographicsReport/demographicsReport.component';
import { ProficiencyReportsComponent } from './proficiencyReports/proficiencyReports.component';
import { SurveyReportsComponent } from './surveyReports/surveyReports.component';




const COMPONENTS = [
  LicenseCashReportsComponent,
  MailingLabelsComponent,
  DemographicsReportComponent,
  ProficiencyReportsComponent,
  SurveyReportsComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    ReportsRoutingModule,
    SharedModule
  ],
  exports: [
    LicenseCashReportsComponent,
    MailingLabelsComponent,
    DemographicsReportComponent,
    ProficiencyReportsComponent,
    SurveyReportsComponent
  ]
})
export class ReportsModule { }